import { Box, GridLayout } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { TrendingAuthorProps } from './types';
import AuthorListCardList from './parts/AuthorListCardList';
import TrendingAuthorSkeleton from './TrendingAuthorSkeleton';

import Title from './parts/Title';

const TrendingAuthor = ({ trendingAuthorsPromise }: TrendingAuthorProps) => {
  return (
    <Box
      className={twJoin(
        'bg-w-bluegray-10 py-[60px]',
        'select-none desktop:py-[100px]'
      )}
    >
      <GridLayout>
        <Box
          className={twJoin(
            'grid-in-content',
            'flex flex-col gap-6',
            'desktop:gap-8'
          )}
        >
          <Title />
          <ErrorBoundary fallback={<TrendingAuthorSkeleton />}>
            <Suspense fallback={<TrendingAuthorSkeleton />}>
              <AuthorListCardList
                trendingAuthorsPromise={trendingAuthorsPromise}
              />
            </Suspense>
          </ErrorBoundary>
        </Box>
      </GridLayout>
    </Box>
  );
};

export default TrendingAuthor;
